import SettingBase from '../settings/util/SettingBase'

class BatchController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'batch'
    this.$state = $state

  }

  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-batch']) {
      this.hasACL[this.acl['setting-batch'][key]] = true;
    }
  }
}

export default BatchController;


// WEBPACK FOOTER //
// ./client/app/components/batch/batch.controller.js